import React from "react";
import { Field } from "formik";

import Input from "components/lib/Shared/Input";

export const BillingDetails = () => {
  return (
    <div className="shadow sm:rounded-md">
      <div className="bg-white py- px-4 space-y-6 sm:p-4">
        <div className="PaymentDetails">
          <div className="grid grid-cols-6 gap-6">
            <div className="col-span-6 sm:col-span-3">
              <Field
                component={Input}
                label="First Name"
                name="firstName"
                placeholder="Enter your first name"
              />
            </div>
            <div className="col-span-6 sm:col-span-3">
              <Field
                component={Input}
                label="Last Name"
                name="lastName"
                placeholder="Enter your last name"
              />
            </div>
            <div className="col-span-6 sm:col-span-3">
              <Field
                component={Input}
                showRequiredAsterisk
                label="Email Address"
                name="email"
                placeholder="Enter your email address"
              />
            </div>
            <div className="col-span-6 sm:col-span-3">
              <Field
                component={Input}
                label="Phone Number"
                name="mobileNumber"
                placeholder="Enter your phone number"
              />
            </div>
            <div className="col-span-6 sm:col-span-3">
              <Field
                component={Input}
                showRequiredAsterisk
                label="Billing Address"
                name="billingAddress"
                placeholder="Enter your billing address"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
